// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2iQki","title":"FrontImage_title__25Mo1"};